import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <div className='footer'>
            <p> 2020 © hule film | ሁሌ ፊልም | Cinema Seats Reserved - Movie Directory using React JS, Demo by <a href="http://github.com/arefathi" > Arefat Hyeredin</a> </p>
            <p>About  ·   API   ·   Contribute   ·   Contact  </p>
        </div>
    )
}

export default Footer
